import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { SimplePanelBone } from '../../organisms/SimplePanelBone/SimplePanelBone';

interface SimplePanelSkeletonProps {
    /** Largeur */
    width?: string;
    /** Hauteur */
    height?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const SimplePanelSkeleton: React.FunctionComponent<SimplePanelSkeletonProps> = function ({
    width = '90%',
    height = '100%',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100vh',
                ...sx,
            }}
        >
            <SimplePanelBone
                width={width}
                height={height}
            />
        </Box>
    );
};
